// 导出埋点事件
import { clickEvent } from "@/api/header";

const EVENT_MAP = {
    CATEGORY_CLICKED: 0,
    TAG_CLICKED: 1,
    GAME_CLICKED: 2,
};

// 点击目录
export const categoryClicked = (params) => {
    return clickEvent({...params, type: EVENT_MAP.CATEGORY_CLICKED})
};

// 点击标签
export const tagClicked = (params) => {
    return clickEvent({...params, type: EVENT_MAP.TAG_CLICKED})
};

// 点击游戏
export const gameClicked = (params) => {
    return clickEvent({...params, type: EVENT_MAP.GAME_CLICKED})
};